import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class BsshDataTableMessageService {
  private subject = new Subject<any>();

  sendMessage(message: string, data?: any) {
    this.subject.next({ text: message, data });
  }

  clearMessages() {
    this.subject.next();
  }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
}
